import React from 'react';
import BenefitsSection from './BenefitsSection';
import trackingActions, {EVENT_ACTION, EVENT_CATEGORY} from '../../../actions/tracking.actions';
import {Button, Message} from 'epic-diesel-common';
import {canReactivate} from '../../../utils/ValidationUtils';
import {navigateToSignin} from '../../../utils/Utils';
import {Affiliate} from '../../../../shared/types';
import {connect} from 'react-redux';
import {OverviewState} from '../../../reducers/overview';
import ReapplyButton from './buttons/ReapplyButton';
import Box from '@material-ui/core/Box';
import {Alert} from '../../../components';

//@ts-ignore
import styles from './HomeHeaderSection.pcss';

const mapDispatchToProps = dispatch => ({
    sendApplyEvent: () => {
        dispatch(
            trackingActions.trackClickEvent(EVENT_CATEGORY.AffiliateSignup, EVENT_ACTION.ClickApply)
        );
    },
    sendReactivateEvent: () => {
        dispatch(
            trackingActions.trackClickEvent(
                EVENT_CATEGORY.AffiliateReactivate,
                EVENT_ACTION.ClickReactivate
            )
        );
    }
});

interface HomeHeaderProps {
    messages: Record<string, string>;
    overviewState: OverviewState;
    affiliateAccount: Affiliate;
    isLoggedIn: boolean;
    enableV2Signup: boolean;
    enableReactivation: boolean;
    sendApplyEvent: VoidFunction;
    sendReactivateEvent: VoidFunction;
}

const HomeHeaderSection: React.FC<HomeHeaderProps> = ({
    isLoggedIn,
    messages,
    sendApplyEvent,
    sendReactivateEvent,
    affiliateAccount,
    overviewState,
    enableReactivation = false,
    enableV2Signup = false
}) => {
    const {title = '', description, benefitsSection, warningText} = overviewState || {};

    const renderApplyButton = () => {
        if (!isLoggedIn) {
            return (
                <Button onClick={navigateToSignin} className={styles.action} theme="dark">
                    <Message code="epic.affiliate.overview.apply.button" />
                </Button>
            );
        }

        const {status} = affiliateAccount || {};
        let button = null;

        switch (status) {
            case 'ACTIVE':
                return null;
            case 'DISABLED':
            case 'DELETED': {
                if (enableReactivation && canReactivate(affiliateAccount)) {
                    button = (
                        <Button
                            className={styles.action}
                            theme="dark"
                            onClick={sendReactivateEvent}
                            to="/reactivate">
                            <Message code="epic.affiliate.common.reactivate.v2" />
                        </Button>
                    );
                    break;
                }

                button = (
                    <Button className={styles.noAction} disabled={true} theme="dark">
                        <Message code="epic.affiliate.common.advocateDisabled" />
                    </Button>
                );
                break;
            }
            case 'PENDING':
            case 'REJECTED':
            case 'INIT':
            default: {
                button = (
                    <ReapplyButton
                        messages={messages}
                        affiliateAccount={affiliateAccount}
                        onClick={sendApplyEvent}
                    />
                );
                break;
            }
        }

        return <div className={styles.partnerButton}>{button}</div>;
    };

    return (
        <>
            {!enableV2Signup && warningText && (
                <Box sx={{width: '90%', margin: '0 auto'}}>
                    <Alert
                        type="SIGNUP-DISABLED"
                        severity="warning"
                        variant="filled"
                        message={<div dangerouslySetInnerHTML={{__html: warningText}} />}
                    />
                </Box>
            )}
            <div className={styles.content}>
                <div className={styles.section}>
                    <h2 dangerouslySetInnerHTML={{__html: title}} />
                    <p dangerouslySetInnerHTML={{__html: description}} />
                </div>

                <BenefitsSection {...benefitsSection} />
                {enableV2Signup && renderApplyButton()}
            </div>
        </>
    );
};

export default connect(null, mapDispatchToProps)(React.memo(HomeHeaderSection));
